import { Component, OnInit, Input } from '@angular/core';
import { Platform } from '@ionic/angular';
import { HelperService } from 'src/app/shared/services/helper_service';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-share-contest',
  templateUrl: './share-contest.page.html',
  styleUrls: ['./share-contest.page.scss'],
})
export class ShareContestPage implements OnInit {

  shareUrl = "https://"+environment.shareurl+"/";
  @Input() contestId: string;
  @Input() matchId: number;
  @Input() matchDetails: any;
  desc: string;
  Url : "https://namma11web.intuceo.com/";
  text : "Use this code to join Contest"
  userName = localStorage.getItem('user_name');
  sharinglink;
  shareDeepLink;
  constructor(
    public helperService: HelperService,
    public platform: Platform,
    private socialSharing : SocialSharing,
    private inappbrowser: InAppBrowser
  ) { }

  ngOnInit() {
    this.desc = `"${this.contestId+'-'+this.matchId}"`;
    // this.sharinglink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/lobbypage/join-contest\n Cheers,\nNamma11`;
    this.sharinglink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/splashdefault/join-contest\n Cheers,\nNamma11`;
    console.log(this.shareUrl);
  }
  
  copyLink(val: any){

    // this.shareDeepLink = `https://${environment.shareurl}/contest-detail/${this.matchId}/${this.contestId}`;
    // this.shareDeepLink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/contest-detail/${this.matchId}/${this.contestId}\n Cheers,\nNamma11`;
    // this.shareDeepLink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/contest-detail/${this.matchId}/${this.contestId}\n Cheers,\nNamma11`;
    this.shareDeepLink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/splashdefault/1/${this.matchId}/${this.contestId}\n Cheers,\nNamma11`;
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.shareDeepLink;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.helperService.presentToast('Your link has been copied!');
  }

  copyText(val: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.helperService.presentToast('Your code has been copied!');
  }
  shareWhatsapp(){
    console.log("What's App");
    console.log(this.sharinglink,this.text);
    // this.shareDeepLink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/contest-detail/${this.matchId}/${this.contestId}\n Cheers,\nNamma11`;
    this.shareDeepLink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/splashdefault/1/${this.matchId}/${this.contestId}\n Cheers,\nNamma11`;
    const isWeb = this.platform.is('desktop') || this.platform.is('mobileweb')
    if (isWeb) {
      const name = "Your+friend"
      const initial = "has+referred+you+on+Namma11%2C+Please+join+with+code";
      const final = "and+earn+prizes+using+following+link+https%3A%2F%2F"+environment.shareurl+"%2Fsplashdefault%2Fjoin-contest+Cheers+Namma11"
      this.inappbrowser.create(`https://api.whatsapp.com/send?text=${name} ${this.userName} ${initial} ${this.contestId+'-'+this.matchId} ${final}`); 
    }
    else{
      this.socialSharing.shareViaWhatsApp(this.shareDeepLink,this.text).then(() => {
      }).catch((e)=>{
        const name = "Your+friend"
        const initial = "has+referred+you+on+Namma11%2C+Please+join+with+code";
        const final = "and+earn+prizes+using+following+link+https%3A%2F%2F"+environment.shareurl+"%2Fsplashdefault%2Fjoin-contest+Cheers+Namma11"
        this.inappbrowser.create(`https://api.whatsapp.com/send?text=${name} ${this.userName} ${initial} ${this.contestId+'-'+this.matchId} ${final}`); 
      });
    }

  }
  shareFacebook(){
    console.log("FaceBook");
    // this.shareDeepLink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/contest-detail/${this.matchId}/${this.contestId}\n Cheers,\nNamma11`;
    this.shareDeepLink = `Your friend "${this.userName}" has referred you on Namma11, Please join with code ${this.contestId+'-'+this.matchId} and earn prizes using following link\n https://${environment.shareurl}/splashdefault/1/${this.matchId}/${this.contestId}\n Cheers,\nNamma11`;
    const isWeb = this.platform.is('desktop') || this.platform.is('mobileweb');
    if (isWeb) {
      const name = "Your+friend"
      const initial = "has+referred+you+on+Namma11%2C+Please+join+with+code";
      const final = "and+earn+prizes+using+following+link+https%3A%2F%2F"+environment.shareurl+"%2Fsplashdefault%2Fjoin-contest+Cheers+Namma11"
      this.inappbrowser.create(`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2F"+environment.shareurl+"%2Fsplashdefault%2Fjoin-contest&quote= ${name} ${this.userName} ${initial} ${this.contestId+'-'+this.matchId} ${final}`); 
    }
    else{
      this.socialSharing.shareViaFacebook(this.shareDeepLink ,this.text).then(() => {
      }).catch((e)=>{
        const name = "Your+friend"
        const initial = "has+referred+you+on+Namma11%2C+Please+join+with+code";
        const final = "and+earn+prizes+using+following+link+https%3A%2F%2F"+environment.shareurl+"%2Fsplashdefault%2Fjoin-contest+Cheers+Namma11"
        this.inappbrowser.create(`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2F${environment.shareurl}%2Fsplashdefault%2Fjoin-contest&quote= ${name} ${this.userName} ${initial} ${this.contestId+'-'+this.matchId} ${final}`); 
  
      });
    }
  }
}
